// components/DNAHelix.tsx
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const DNAHelix = () => {
  return (
    <div className="absolute inset-0 z-0">
      <Canvas camera={{ position: [0, 0, 15], fov: 50 }}>
        <ambientLight intensity={0.6} />
        <pointLight position={[10, 10, 10]} intensity={1} />
        <Helix />
        <OrbitControls enableZoom={false} enablePan={false} autoRotate />
      </Canvas>
    </div>
  );
};

const Helix = () => {
  const group = useRef<THREE.Group>(null);

  useFrame(({ clock }) => {
    if (group.current) {
      group.current.rotation.y = clock.getElapsedTime() * 0.3;
    }
  });

  const helix = [];
  const total = 100;
  const separation = 0.3;

  for (let i = 0; i < total; i++) {
    const angle = i * 0.3;
    const y = (i - total / 2) * separation;
    const x1 = Math.cos(angle) * 2;
    const z1 = Math.sin(angle) * 2;
    const x2 = Math.cos(angle + Math.PI) * 2;
    const z2 = Math.sin(angle + Math.PI) * 2;

    helix.push(
      <mesh key={`sphere1-${i}`} position={[x1, y, z1]}>
        <sphereGeometry args={[0.1, 16, 16]} />
        <meshStandardMaterial color="#2B6CB0" />
      </mesh>
    );
    helix.push(
      <mesh key={`sphere2-${i}`} position={[x2, y, z2]}>
        <sphereGeometry args={[0.1, 16, 16]} />
        <meshStandardMaterial color="#63B3ED" />
      </mesh>
    );

    // Connecting bar (base pair)
    helix.push(
      <mesh key={`bar-${i}`} position={[0, y, 0]}>
        <cylinderGeometry args={[0.02, 0.02, 4, 8]} />
        <meshStandardMaterial color="#CBD5E0" />
        <group rotation={[0, angle, 0]} />
      </mesh>
    );
  }

  return <group ref={group}>{helix}</group>;
};

export default DNAHelix;
